import React from "react";
import styled from "styled-components";
import colors from "../../styles/colors";

const BoxLastMatch = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: rgba(163, 27, 27, 0.06);
    border: 1px solid rgba(163, 27, 27, 0.3);
    border-radius: 10px;
    padding: 16px;
    cursor: pointer;
    transition: border-color 0.2s, background-color 0.2s;
    position: relative;
    overflow: hidden;

    &:hover {
        background-color: rgba(163, 27, 27, 0.12);
        border-color: rgba(163, 27, 27, 0.6);
    }

    & .hover-content {
        display: none;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(20, 20, 20, 0.92);
        padding: 16px;

        & img {
            width: 100px;
            height: 100px;
            object-fit: contain;
            margin-bottom: 10px;
        }

        & .hover-ppv-name {
            font-weight: 700;
            font-size: 15px;
            color: #fff;
            text-align: center;
            margin-bottom: 4px;
        }

        & .hover-ppv-year {
            font-size: 13px;
            color: rgba(255, 255, 255, 0.45);
        }
    }

    &:hover .hover-content {
        display: flex;
    }

    &:hover .normal-content {
        opacity: 0;
    }
`;

const MatchLabel = styled.div`
    font-size: 10px;
    font-weight: 700;
    color: rgba(255, 255, 255, 0.35);
    text-transform: uppercase;
    letter-spacing: 0.1em;
    margin-bottom: 12px;
`;

const BoxLastMatchType = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    & .box-wrestlers {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        gap: 4px;
        width: 100%;
    }

    & .box-name-wrestlers {
        text-align: center;
        margin-top: 8px;
        line-height: 1.5;

        & .name-wrestler {
            font-size: 13px;
            text-transform: uppercase;
            font-weight: 700;
            color: #fff;
        }

        & .color-gray {
            color: rgba(255, 255, 255, 0.35);
            font-size: 12px;
            margin: 0 3px;
        }
    }

    &.single img, &.generic img {
        width: 80px;
        height: 80px;
        object-fit: cover;
        object-position: top;
        border-radius: 50%;
        border: 2px solid rgba(163, 27, 27, 0.4);
    }

    &.triple img, &.tag img, &.fatal img {
        width: 52px;
        height: 52px;
        object-fit: cover;
        object-position: top;
        border-radius: 50%;
        border: 2px solid rgba(163, 27, 27, 0.4);
    }
`;

const PpvInfo = styled.div`
    margin-top: 12px;
    padding-top: 10px;
    border-top: 1px solid rgba(255, 255, 255, 0.07);
    text-align: center;

    & .name-ppv-text {
        font-size: 13px;
        font-weight: 700;
        color: rgba(255, 255, 255, 0.7);
        text-transform: uppercase;
        letter-spacing: 0.05em;
    }

    & .year-ppv-text {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.35);
        margin-top: 2px;
    }
`;

function WrestlerLastMatch({ wrestlerData, onNavigateToPpv }: any) {
    const renderMatchType = (match: any) => {
        const { type_match, wrestlers } = match;

        const getClass = () => {
            switch (type_match.type) {
                case 'single': return 'single';
                case 'triple': return 'triple';
                case 'fatal': return 'fatal';
                case 'tag': return 'tag';
                default: return 'generic';
            }
        };

        if (type_match.type !== 'single' && type_match.type !== 'triple' && type_match.type !== 'fatal' && type_match.type !== 'tag') {
            return (
                <BoxLastMatchType className="generic">
                    <div className="box-wrestlers">
                        <img
                            src={process.env.REACT_APP_STORAGE_URL + wrestlerData.avatar_path}
                            alt={wrestlerData.name}
                        />
                    </div>
                    <div className="box-name-wrestlers">
                        <span className="name-wrestler">{type_match.name}</span>
                    </div>
                </BoxLastMatchType>
            );
        }

        return (
            <BoxLastMatchType className={getClass()}>
                <div className="box-wrestlers">
                    {wrestlers.map((w: any, key: number) => (
                        <img key={key} src={process.env.REACT_APP_STORAGE_URL + w.avatar_path} alt={w.name} />
                    ))}
                </div>
                <div className="box-name-wrestlers">
                    {wrestlers.map((w: any, key: number) => (
                        <React.Fragment key={key}>
                            <span className="name-wrestler">{w.name}</span>
                            {key < wrestlers.length - 1 && <span className="color-gray"> VS </span>}
                        </React.Fragment>
                    ))}
                </div>
            </BoxLastMatchType>
        );
    };

    if (!wrestlerData.last_fight || wrestlerData.last_fight.length === 0) {
        return null;
    }

    const lastMatch = wrestlerData.last_fight[0];

    return (
        <BoxLastMatch onClick={onNavigateToPpv}>
            <div className="normal-content">
                <MatchLabel>Ultimo match</MatchLabel>
                {renderMatchType(lastMatch)}
                <PpvInfo>
                    <div className="name-ppv-text">{lastMatch.ppv.ppv_description.name}</div>
                    <div className="year-ppv-text">{lastMatch.ppv.date.split('-')[2]}</div>
                </PpvInfo>
            </div>

            <div className="hover-content">
                <img
                    src={process.env.REACT_APP_STORAGE_URL + lastMatch.ppv.img_path}
                    alt={lastMatch.ppv.ppv_description.name}
                />
                <div className="hover-ppv-name">{lastMatch.ppv.ppv_description.name}</div>
                <div className="hover-ppv-year">{lastMatch.ppv.date.split('-')[2]}</div>
            </div>
        </BoxLastMatch>
    );
}

export default WrestlerLastMatch;
